import moment from "moment";

export default {
    methods: {
        // 文字列からmomentオブジェクトを返す
        moment(dateTime) {
            return moment(dateTime);
        },

        // 時間文字列から指定日または当日のmomentオブジェクトを返す
        momentFromHour(hourMinute, todayMoment = null) {
            let momentDate = moment()
            if (todayMoment) {
                momentDate = todayMoment.clone();
            }
            return moment(momentDate.format('YYYY-MM-DD') + ' ' + hourMinute);
        },

        // ページトップにスクロール
        scrollTop() {
            window.scrollTo({top: 0});
        },
    }
}
